import { configureStore } from "@reduxjs/toolkit";
import { userSlice } from "./userSlice";
import { persistReducer } from 'redux-persist';


import { combineReducers } from 'redux';

import storage from 'redux-persist/lib/storage';
import { thunk } from "redux-thunk";


const reducers = combineReducers({
    DreamsAdminUser: userSlice.reducer,
});

const persistConfig = {
    key: 'root',
    storage
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(thunk)
});
